<template>
  <b-modal
    v-model="modalBranch"
    id="mc-modal-branches"
    ref="mc-modal-branches"
    no-close-on-backdrop
    no-close-on-esc
    dialog-class="mc-modal-warning"
    scrollable
    size="md"
    centered
  >
    <div class="card-body p-2">
      <b-skeleton-wrapper :loading="!options.length">
        <template #loading>
          <div class="mb-3">
            <b-skeleton width="100%" />
          </div>
          <b-row>
            <b-col cols="6" v-for="n in 2" :key="n">
              <b-skeleton width="65%" />
            </b-col>
          </b-row>
        </template>
          <div class="mc-branches-message mb-3" v-html="message"></div>
        <b-form-radio-group
          v-model="selected"
          value-field="id"
          text-field="name"
          class="mc-branches"
          v-if="options.length > 1"
        >
          <b-row>
            <b-col cols="6" v-for="(val, key) in options" :key="key">
              <b-form-radio :value="val.id">{{ val.name }}</b-form-radio>
            </b-col>
          </b-row>
        </b-form-radio-group>
      </b-skeleton-wrapper>
    </div>
    <template #modal-header>
      <b-skeleton-wrapper :loading="!options.length">
        <template #loading>
          <b-skeleton width="80%"/>
        </template>
        <div class="text-white">{{ options.length === 1 ? $t('invoice.modal.title.attention') : $t('invoice.modal.title.selectBranch') }}</div>
      </b-skeleton-wrapper>
    </template>
    <template #modal-footer>
      <div class="d-flex mx-0">
        <slot name="button-action">
          <McButton @click="handleCancel" variant="secondary" class="me-2" :text="$t('global.cancel')" />
          <McButton @click="handleSubmit" variant="primary" :text="$t('global.alert.text.confirm')" />
        </slot>
      </div>
    </template>
  </b-modal>
</template>
<script>
import * as Branch from '@/services/rest-api/lib/branch/branch'
import McButton from '@/components/McButton'
export default {
  components: {
    McButton
  },
  props: {
    value: {
      type: Boolean,
      require: true
    },
  },
  data() {
    return {
      selected: null,
      options: []
    }
  },
  computed: {
    modalBranch: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('update:value', newVal)
      }
    },
    message() {
      if (this.options.length === 1) {
        return `${this.$t('invoice.modal.msg.oneBranch')} <span>${this.options[0].name}</span>, ${this.$t('invoice.modal.text.confirm')}?`
      } else {
        return this.$t('invoice.modal.msg.selectBranch')
      }
    }
  },
  created() {
    this.getBranch()
  },
  methods: {
    async getBranch() {
      const { errors, message, data } = await Branch.getExternal({ page: 1, limit: 100 })
      if (errors) {
        this.$mcToast.error(message)
        return
      }
      this.options = data.paginated_result

      if (this.options.length === 1) {
        this.selected = this.options[0]['id']
      }
    },
    handleSubmit() {
      if (!this.selected) {
        this.$mcToast.error(this.$t('global.text.noSelected'))
        return 
      }
      this.modalBranch = false
      this.$emit('submit', this.selected)
    },
    handleCancel() {
      this.modalBranch = false
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.mc-branches) {
  .custom-radio {
    label{
      margin-left: 6px;
    }
    
  }
}

:deep(.mc-branches-message) {
  span{
    font-weight: 800;
  }
}
</style>